(function(){
  function init(root){
    var nav=root.querySelector('[data-sjw-ed-chapters]');
    if(!nav||nav.__sjwEdChaptersReady)return;
    nav.__sjwEdChaptersReady=true;
    var links=[].slice.call(nav.querySelectorAll('a[href^="#"]'));
    var targets=links.map(function(link){
      var id=link.getAttribute('href').slice(1);
      return {link:link,node:id?document.getElementById(id):null};
    }).filter(function(item){return item.node;});
    if(!targets.length)return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scroller=nav.querySelector('.sjw-ed-chapters__scroll');
    function revealHorizontally(link){
      if(!scroller)return;
      var linkBox=link.getBoundingClientRect();
      var scrollBox=scroller.getBoundingClientRect();
      var next=scroller.scrollLeft;
      if(linkBox.left<scrollBox.left+8)next-=scrollBox.left+8-linkBox.left;
      else if(linkBox.right>scrollBox.right-8)next+=linkBox.right-scrollBox.right+8;
      else return;
      if(scroller.scrollTo)scroller.scrollTo({left:Math.max(0,next),behavior:reduce?'auto':'smooth'});else scroller.scrollLeft=Math.max(0,next);
    }
    function setActive(link,bringIntoView){
      links.forEach(function(other){other.removeAttribute('aria-current');});
      link.setAttribute('aria-current','location');
      if(bringIntoView)revealHorizontally(link);
    }
    links.forEach(function(link){
      link.addEventListener('click',function(){
        setActive(link,false);
      });
    });
    if(!('IntersectionObserver' in window))return;
    var visible={};
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){visible[entry.target.id]=entry.isIntersecting?entry.intersectionRatio:0;});
      var active=targets.slice().sort(function(a,b){return (visible[b.node.id]||0)-(visible[a.node.id]||0);})[0];
      if(!active||!(visible[active.node.id]>0))return;
      setActive(active.link,true);
    },{rootMargin:'-22% 0px -62% 0px',threshold:[0,.01,.25,.6]});
    targets.forEach(function(item){observer.observe(item.node);});
  }

  function initReadingMode(){
    var old=window.__sjwEditorialReadingMode;
    if(old&&old.destroy)old.destroy();

    var page=document.querySelector('#MainContent .sjw-editorial');
    var chapter=page&&page.querySelector('[data-sjw-ed-chapters],.sjw-dg-nav');
    var header=document.querySelector('.header-section');
    if(!page||!chapter||!header)return;

    var html=document.documentElement;
    var body=document.body;
    var away=false;
    var hidden=false;
    var destroyed=false;
    var frameId=0;
    var headerHeight=0;
    var editorHeaderSelected=false;
    var ownedInert=false;
    var graceUntil=0;
    var graceTimer=0;
    var originalAriaHidden=header.getAttribute('aria-hidden');

    if(!('inert' in HTMLElement.prototype)||(window.Shopify&&window.Shopify.designMode))return;

    function y(){return window.scrollY||document.documentElement.scrollTop||0;}
    function measure(){
      var cssHeight=parseFloat(getComputedStyle(html).getPropertyValue('--header-height-static'))||0;
      headerHeight=Math.max(header.offsetHeight||0,cssHeight,72);
    }
    function overlayOpen(){
      return !!(
        header.classList.contains('is-hover')||
        header.matches(':focus-within')||
        header.querySelector('.is-active,[aria-expanded="true"]')||
        body.classList.contains('locked')||
        body.classList.contains('sjw-mc-on')||
        body.style.position==='fixed'||
        body.style.overflow==='hidden'||
        document.querySelector('.js-predictive-search.is-active,.js-cart-drawer.is-active,[data-js-window="overlay"].is-active')||
        (document.activeElement&&document.activeElement.matches&&document.activeElement.matches('a[href="#MainContent"]'))||
        (window.themeCore&&window.themeCore.isMegaMenuOpened)||
        editorHeaderSelected
      );
    }
    function restoreHeaderAccess(){
      header.classList.remove('sjw-ed-reading-hidden');
      html.classList.remove('sjw-ed-reading-mode');
      if(ownedInert){header.removeAttribute('inert');ownedInert=false;}
      if(originalAriaHidden===null)header.removeAttribute('aria-hidden');
      else header.setAttribute('aria-hidden',originalAriaHidden);
      hidden=false;
    }
    function hideHeader(){
      if(!header.hasAttribute('inert')){header.setAttribute('inert','');ownedInert=true;}
      header.setAttribute('aria-hidden','true');
      header.classList.add('sjw-ed-reading-hidden');
      html.classList.add('sjw-ed-reading-mode');
      hidden=true;
    }
    function update(){
      frameId=0;
      if(destroyed)return;
      var top=y();
      if(top<=12){
        away=false;
        header.classList.remove('is-collapsed','header-section--top-collapsed','sjwh-pill');
        measure();
      }else if(!away&&top>headerHeight){
        away=true;
      }
      var suspended=overlayOpen();
      if(suspended)graceUntil=Date.now()+700;
      var shouldHide=away&&!suspended&&Date.now()>=graceUntil;
      if(!shouldHide)header.classList.remove('is-collapsed','header-section--top-collapsed');
      if(shouldHide&&!hidden)hideHeader();
      else if(!shouldHide&&hidden)restoreHeaderAccess();
      if(away&&!suspended&&!shouldHide&&!graceTimer){
        graceTimer=setTimeout(function(){graceTimer=0;schedule();},Math.max(0,graceUntil-Date.now())+20);
      }
    }
    function schedule(){
      if(!frameId)frameId=requestAnimationFrame(update);
    }
    function scheduleAfterInteraction(){schedule();setTimeout(schedule,0);setTimeout(schedule,720);}
    function onResize(){if(y()<=12)measure();schedule();}
    function onPageShow(){if(y()<=12)measure();schedule();}
    function onSectionSelect(event){
      editorHeaderSelected=!!(event.target&&event.target.contains(header));
      schedule();
    }
    function onSectionDeselect(){editorHeaderSelected=false;schedule();}

    measure();
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',onResize,{passive:true});
    window.addEventListener('pageshow',onPageShow);
    document.addEventListener('focusin',scheduleAfterInteraction,true);
    document.addEventListener('focusout',scheduleAfterInteraction,true);
    document.addEventListener('click',scheduleAfterInteraction,true);
    document.addEventListener('keydown',scheduleAfterInteraction,true);
    document.addEventListener('shopify:section:select',onSectionSelect);
    document.addEventListener('shopify:section:deselect',onSectionDeselect);

    var observer=null;
    if('MutationObserver' in window){
      observer=new MutationObserver(schedule);
      observer.observe(header,{attributes:true,subtree:true,attributeFilter:['class','aria-expanded']});
      observer.observe(body,{attributes:true,attributeFilter:['class','style']});
    }

    function destroy(){
      if(destroyed)return;
      destroyed=true;
      if(frameId)cancelAnimationFrame(frameId);
      if(graceTimer)clearTimeout(graceTimer);
      if(observer)observer.disconnect();
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',onResize);
      window.removeEventListener('pageshow',onPageShow);
      document.removeEventListener('focusin',scheduleAfterInteraction,true);
      document.removeEventListener('focusout',scheduleAfterInteraction,true);
      document.removeEventListener('click',scheduleAfterInteraction,true);
      document.removeEventListener('keydown',scheduleAfterInteraction,true);
      document.removeEventListener('shopify:section:select',onSectionSelect);
      document.removeEventListener('shopify:section:deselect',onSectionDeselect);
      restoreHeaderAccess();
    }
    window.__sjwEditorialReadingMode={destroy:destroy};
    update();
  }

  function start(){
    [].slice.call(document.querySelectorAll('.sjw-editorial')).forEach(init);
    initReadingMode();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
  document.addEventListener('shopify:section:unload',function(){setTimeout(start,0);});
})();
